// Modules
import { Children, Fragment } from 'react';
import cn from 'classnames';

// Types
import type { JSX, MouseEvent } from 'react';
import type { TStepperProps } from './Stepper.type';

// Styles
import styles from './styles/Stepper.module.scss';

// Components
import Step from './Step';

// Helpers
import { getStepProps } from './Stepper.helper';
import { isFunction } from '../../helpers';

// Constants
import { STEP_DISPLAY_NAME, STEPPER_DEFAULT_PROPS } from './Stepper.constant';

const Stepper = (props: TStepperProps) => {
	const {
		activeStep = STEPPER_DEFAULT_PROPS.activeStep,
		children,
		className,
		onChange,
		orientation = STEPPER_DEFAULT_PROPS.orientation,
		stepClassName,
		textPosition = STEPPER_DEFAULT_PROPS.textPosition,
		...restProps
	} = props;

	const stepperCN = cn(styles.legion_stepper, className, styles[orientation!], styles[textPosition!]);
	const stepCN = cn(styles.stepper_step, stepClassName)

	return (
		<div className={stepperCN} {...restProps}>
			{Children.toArray(children).filter(child => (child as JSX.Element)?.type?.displayName === STEP_DISPLAY_NAME).map((child, index, arrChildren) => {
				const { key, onClick, ...childProps } = (child as JSX.Element).props
				const stepKey = key || `step-${index}`;
				const {
					isFirst,
					position,
					status,
				} = getStepProps(activeStep!, arrChildren.length, index);
				const connectorCN = cn(styles.stepper_connector, {
					[styles.active]: activeStep! >= index,
				});

				const handleClickStep = (e: MouseEvent<HTMLDivElement>) => {
					isFunction(onClick) && onClick(e);
					isFunction(onChange) && onChange(index);
				}

				return (
					<Fragment key={stepKey}>
						{isFirst || (
							<div className={connectorCN}/>
						)}
						<Step
							{...childProps}
							className={stepCN}
							status={status}
							textPosition={textPosition}
							position={position}
							onClick={handleClickStep}
							orientation={orientation}
						/>
					</Fragment>
				)
			})}
		</div>
	);
}

export default Stepper;
